import styled from 'styled-components'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100dvh;
  background-color: rgba(0, 0, 0, 0.3); // 반투명 검정 배경
  z-index: 999; 
  display: flex;
  justify-content: center;
  align-items: center;
`
const ModalBox = styled.div`
  padding: 20px;
  min-width: 272px;
  background-color: ${(props) => props.theme.colors.neutral[100]};
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 1000;
`
const ModalLayout = ({children, onClose}) => {
  return (
    <Overlay onClick={onClose}>
      <ModalBox  onClick={e => e.stopPropagation()}>
        {children}
      </ModalBox>
    </Overlay>
  )
}

export default ModalLayout
